import * as tslib_1 from "tslib";
import { baseRequest } from "./api";
import { API_REFERENCE } from "@base/constants/base.constants";
export const getAssetDetails = (assetId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    const params = `?filter=${encodeURI(JSON.stringify({ deviceTypeId: "1" }))}`;
    return yield baseRequest({ url: API_REFERENCE["asset"]["assetdetails"] + assetId + params });
});
export const getAssetPreplay = ({ assetId, drm }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    const params = `?assetId=${assetId}&drm=${drm}`;
    const showError = !navigator.userAgent.includes("CriOS");
    return yield baseRequest({ url: API_REFERENCE["asset"]["preplay"] + params, showError });
});
export const addBookmark = (body) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    return yield baseRequest({
        method: "POST",
        url: API_REFERENCE["asset"]["bookmark"],
        body
    });
});
export const addToWatchlist = (assetId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    return yield baseRequest({
        method: "POST",
        url: API_REFERENCE['asset']['addwatchlist'],
        body: { assetId }
    });
});
//# sourceMappingURL=assets.js.map